import {Grid, Typography} from "@mui/material";

export const Tarjeta_Caracteristica = ({item, index, click}) => {

    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1, cursor: 'pointer'}}
        >


            <Grid container size={4} sx={{justifyContent: 'flex-start', backgroundColor: '#000'}}>
                <img src={item.img} width={50} height={50}/>
            </Grid>

            <Grid container size={8} sx={{justifyContent: 'flex-end'}}>
                <Typography sx={{fontSize: 18}}>{item.nombre}</Typography>
            </Grid>


        </Grid>
    )
}